import Button from '../Button';

import './export-button.scss';

interface ExportButtonProps {
  onClick: () => void;
  loading?: boolean;
  disabled?: boolean;
  label?: string;
}

/*
 * The download every list offers, styled once. Pages render it inside
 * PageActions so it sits on the title row.
 */
export default function ExportButton({
  onClick,
  loading = false,
  disabled = false,
  label = 'Export',
}: ExportButtonProps) {
  return (
    <Button
      className="export-button"
      icon="pi pi-download"
      onClick={onClick}
      loading={loading}
      disabled={disabled}
      label={label}
      outlined
    />
  );
}
